export default {"src":"/_next/static/media/maven-logo.72dd578d.svg","height":38,"width":465};